import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { KeycloakService } from 'keycloak-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { initializer } from './init/AppInit';
import { AuthService } from './AuthService';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LoaderInterceptor } from './pages/general/interceptors/loader.interceptor';
import { SecuredHttpInterceptor } from './pages/general/interceptors/secured-http.interceptor';
import { ErrorInterceptor } from './pages/general/interceptors/error.interceptor';


export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
    KeycloakService,provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
   {provide:APP_INITIALIZER,useFactory:initializer,
    multi:true,deps:[KeycloakService]},
    {provide:HTTP_INTERCEPTORS,useClass:LoaderInterceptor,multi:true},
    {provide:HTTP_INTERCEPTORS,useClass:SecuredHttpInterceptor,multi:true},
    {provide:HTTP_INTERCEPTORS,useClass:ErrorInterceptor,multi:true},
    AuthService
]
};


